module.exports = __webpack_public_path__ + "static/media/LEDMiniBox.c98ffc0a.mp4";